import { transformMany as transformUsers } from '@src/api/transformers/userTransformer'
import _ from 'lodash'

export const transform = (item, primaryOfficeId) => {
  const office = {
    id: item.id,
    isPrimary: item.id === primaryOfficeId,
    integrationId: item.integrationId,
    franchiseId: item.franchiseId,
    tradeName: item.tradeName,
    legalName: item.legalName,
    status: item.status,
    isReadOnly: item.status === 'Closed' || item.status === 'Transfer',
    hideFromTabs: item.status === 'Rescinded',
    licensingStatus: item.licensingStatus,
    contractId: item.contractId,
    entityNMLS: item.entityNMLS,
    addressStreet: item.addressStreet,
    city: item.city,
    state: item.state,
    zipCode: item.zipCode,
    phone: item.phone,
    email: item.email,
    website: item.website,
    isIntegratedWithLHP: _.get(_.find(item.integrations, { name: 'Lhp' }, []), 'active', false),
    vanityUrl: item.vanityUrl,
    locationDetails: item.locationDetails,
    shortDescription: item.shortDescription,
    webAdmin: item.webAdmin,
    webAdminName: item.webAdmin?.name,
    fdcName: item.fdc?.name || item.franchiseDevelopmentConsultant?.name,
    mainContactName: item.mainContactName,
    associatedOffices: item.associatedOffices,
    systemOfRecord: item.systemOfRecord,
    contactCalendlyLink: item.contactCalendlyLink,
    users: transformUsers(item.users),
    licenses: item.licenses.map((license) => ({
      state: license.service_area,
      number: license.license_number,
    })),
    originalLicenses: item.licenses.map((license) => ({
      state: license.service_area,
      number: license.license_number,
    })),
    canAddMoreLicenses: item.licenses.length < 4,
    actualOpenDate: item.actualOpenDate,
    terminationDate: item.terminationDate,
    primaryOpsContact: item.primaryOpsContact,
    isLicenseChangePending:
      item.pendingTasks?.some((task) => task.type === 'STATE_LICENSE' && task.status === 'PENDING') || false,
    pendingLicenses:
      item.pendingTasks
        ?.filter((task) => task.type === 'STATE_LICENSE' && task.status === 'PENDING')
        .map((x) => x.additionalData.requestedLicense) || [],
    apiOfficeObject: item,
  }

  return {
    ...office,
    getStateAddress() {
      const { city, state, zipCode } = office

      if (city && state && zipCode) {
        return `${city}, ${state} - ${zipCode} `
      }

      return ''
    },
  }
}
export const transformMany = (items, primaryOfficeId = 0) => {
  return items.map((item) => transform(item, primaryOfficeId))
}
